module.exports = __webpack_public_path__ + "img/has-receive.8124bbad.png";